import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";

export const fetchDrawDBApps = (params?: any) => {
  return {
    type: ReduxActionTypes.FETCH_DRAW_DB_APPS_INIT,
    payload: {
      drawdbGroupId: params?.drawdbGroupId,
      name: params?.name,
    },
  };
};

export const fetchDrawDBGroups = (params?: any) => {
  return {
    type: ReduxActionTypes.FETCH_DRAW_DB_GROUPS_INIT,
    payload: {},
  };
};

export const createDrawDBGroup = (params?: any) => {
  return {
    type: ReduxActionTypes.CREATE_DRAW_DB_GROUP_INIT,
    payload: {
      name: params?.name,
    },
  };
};

export const updateDrawDBGroup = (params?: any) => {
  return {
    type: ReduxActionTypes.UPDATE_DRAW_DB_GROUP_INIT,
    payload: {
      id: params?.id,
      name: params?.name,
      onFailure: params?.onFailure,
    },
  };
};

export const createDrawDB = (params?: any) => {
  return {
    type: ReduxActionTypes.CREATE_DRAW_DB_INIT,
    payload: {
      name: params?.name,
      dbType: params?.dbType,
      drawdbGroupId: params?.drawdbGroupId,
      layout: params?.layout,
    },
  };
};

export const fetchDrawDBApp = (id: string) => {
  return {
    type: ReduxActionTypes.FETCH_DRAW_DB_APP_INIT,
    payload: {
      id,
    },
  };
};

export const editDrawDB = (params: any) => {
  return {
    type: ReduxActionTypes.EDIT_DRAW_DB_INIT,
    payload: {
      ...params,
    },
  };
};

export const deleteDrawDBApp = (params: any) => {
  return {
    type: ReduxActionTypes.DELETE_DRAW_DB_APP_INIT,
    payload: {
      ...params,
    },
  };
};

export const deleteDrawDBGroup = (params: any) => {
  return {
    type: ReduxActionTypes.DELETE_DRAW_DB_GROUP_INIT,
    payload: {
      ...params,
    },
  };
};

export const exportDrawDBApp = (params: any) => {
  return {
    type: ReduxActionTypes.EXPORT_DRAW_DB_APP_INIT,
    payload: {
      ...params,
    },
  };
};

export const importDrawDBApp = (params: any) => {
  return {
    type: ReduxActionTypes.IMPORT_DRAW_DB_APP_INIT,
    payload: {
      ...params,
    },
  };
};

export const inviteUsersToDrawDBGroup = (params: any) => {
  return {
    type: ReduxActionTypes.INVITE_USERS_TO_DRAW_DB_GROUP_INIT,
    payload: {
      ...params,
    },
  };
};

export const fetchDrawDBGroupUsers = (params: any) => {
  return {
    type: ReduxActionTypes.FETCH_DRAW_DB_GROUP_USERS_INIT,
    payload: {
      ...params,
    },
  };
};

export const deleteDrawDBGroupMember = (params: any) => {
  return {
    type: ReduxActionTypes.DELETE_DRAW_DB_GROUP_MEMBER_INIT,
    payload: {
      ...params,
    },
  };
};

export const fetchDrawDBPermissionGroups = (params: any) => {
  return {
    type: ReduxActionTypes.FETCH_DRAW_DB_PERMISSION_GROUPS_INIT,
    payload: {
      ...params,
    },
  };
};